<header>
  <home-top-nav-bar navTitle="Dashboard (next)" />
</header>

<article>
  <div class="dashboard-container">
    <user-details />
    <ui-dashboard [uiOptions]="dashboardOptions" [uiWidgets]="dashboardWidgets" (uiChange)="onChange($event)" (uiResizeStop)="onResize($event)" />
  </div>
</article>
